"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateHostTerminal = exports.useUpdateTerminalOffline = exports.useCreateTerminalOffline = exports.useFetchTerminalOffline = void 0;
const react_redux_1 = require("react-redux");
const terminalOfflineAction_1 = require("./terminalOfflineAction");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_router_dom_1 = require("react-router-dom");
const useFetchTerminalOffline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchTerminalOfflineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOffline/fetch'].loading);
    const fetchTerminalOfflineData = (0, react_redux_1.useSelector)((state) => state['terminalOffline/fetch'].data);
    const fetchTerminalOfflineError = (0, react_redux_1.useSelector)((state) => state['terminalOffline/fetch'].error);
    const fetchTerminalOffline = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, terminalOfflineAction_1.fetch)(payload));
    });
    return {
        fetchTerminalOffline,
        fetchTerminalOfflineLoading,
        fetchTerminalOfflineData,
        fetchTerminalOfflineError
    };
};
exports.useFetchTerminalOffline = useFetchTerminalOffline;
const useCreateTerminalOffline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createTerminalOfflineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOffline/create'].loading);
    const createTerminalOfflineData = (0, react_redux_1.useSelector)((state) => state['terminalOffline/create'].data);
    const createTerminalOfflineError = (0, react_redux_1.useSelector)((state) => state['terminalOffline/create'].error);
    const createTerminalOffline = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, terminalOfflineAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in creating terminal offline");
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        createTerminalOffline,
        createTerminalOfflineLoading,
        createTerminalOfflineData,
        createTerminalOfflineError
    };
};
exports.useCreateTerminalOffline = useCreateTerminalOffline;
const useUpdateTerminalOffline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateTerminalOfflineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOffline/update'].loading);
    const updateTerminalOfflineData = (0, react_redux_1.useSelector)((state) => state['terminalOffline/update'].data);
    const updateTerminalOfflineError = (0, react_redux_1.useSelector)((state) => state['terminalOffline/update'].error);
    const updateTerminalOffline = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, terminalOfflineAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res;
            }
        }
        catch (err) {
            onComplete(false, true, err);
        }
    });
    return {
        updateTerminalOffline,
        updateTerminalOfflineLoading,
        updateTerminalOfflineData,
        updateTerminalOfflineError
    };
};
exports.useUpdateTerminalOffline = useUpdateTerminalOffline;
const useCreateHostTerminal = () => {
    const history = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const createHostTerminalLoading = (0, react_redux_1.useSelector)((state) => state['terminalOffline/createHost'].loading);
    const createHostTerminalData = (0, react_redux_1.useSelector)((state) => state['terminalOffline/createHost'].data);
    const createHostTerminalError = (0, react_redux_1.useSelector)((state) => state['terminalOffline/createHost'].error);
    const createHostTerminal = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let result = yield (0, AuthGuard_1.isLoggedIn)();
            if (!result) {
                history('/auth/sign-in');
                return;
            }
            let res = yield dispatch((0, terminalOfflineAction_1.createHost)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error.message;
            }
        }
        catch (err) {
            onComplete(false, true, err);
        }
    });
    return {
        createHostTerminal,
        createHostTerminalLoading,
        createHostTerminalData,
        createHostTerminalError
    };
};
exports.useCreateHostTerminal = useCreateHostTerminal;
